import OrderCancelModal from './OrderCancelModal'

export default OrderCancelModal
